<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopupMultiple
			v-if="content[which].InterimQA && questionPopupDisplay && content[which].interimQAmultiple === true"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-bind:questionPopupDisplay="questionPopupDisplay"
			v-on:close-then="closeThen"
		></QuestionPopupMultiple>
	</teleport>
	<teleport to="body">
		<OverlayModal 
			v-if="content[which].columnOverlay && overlayDisplay" 
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
			id="overlay-modal"
		>
			<TabbedContent
				v-bind:which="which"
				v-bind:tabType="content[which].whichTabbedContent"
			>
			</TabbedContent>
		</OverlayModal>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopupMultiple from '@/components/QuestionPopupMultiple'
import OverlayModal from '@/components/OverlayModal'
import TabbedContent from '@/components/TabbedContent.vue'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopupMultiple,
		OverlayModal,
		TabbedContent
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'cycle-4',
			overlayDisplay: false,
			questionPopupDisplay: false,
			content: {
				gordon: {
					classes: 'cycle cycle-gordon',
					prevTab: 'cycle-3/',
					nextTab: 'final/',
					nextTabInterim: true,
					whichTabbedContent: 'cycle-3',
					whichTabbedContentAns: 'cycle-4',
					columnA: 258,
					columnAbutton: 196,
					columnButtonAction: 'show-overlay',
					columnOverlay: 'cycle-3',
					columnB: 323,
					columnC: 321,
					columnChide: true,
					interimQAmultiple: true,
					InterimQA: [
						{
							layoutClass: 'two-col gordon-cycle-4',
							type: 'radio',
							question: 'How would you manage Mr. Gordon’s venetoclax dosing during Cycle 4 based on his second occurrence of Grade 4 neutropenia?',
							choices: [
								'Complete Cycle 4 before pausing venetoclax to allow for count recovery',
								'Interrupt venetoclax at the time of onset until neutropenia has resolved to Grade 1 or baseline, then resume venetoclax at a dose of 400 mg',
								'Interrupt venetoclax at the time of onset until ANC ≥500/μL, then resume venetoclax at a dose of 400 mg',
								'Interrupt venetoclax at the time of onset until neutropenia has resolved to Grade 1 or baseline, then resume venetoclax at a reduced dose (300 mg)'
							],
							answer: '3',
							answerSize: 957,
							redirect: null,
							nextQ: 1
						},
						{
							layoutClass: 'one-col gordon-cycle-4',
							showTabs: true,
							type: 'radio',
							question: 'In your practice, do you typically administer G-CSF to CLL patients, like Mr. Gordon, who are presenting with Grade 4 neutropenia?',
							choices: [
								'Yes',
								'No',
								'Other'
							],
							answer: '-1',
							answerLong: 'G-CSF can be administered at the discretion of the treating physician and per institutional guidelines. In the CLL14 trial, G-CSF use was 43.5% in patients receiving VEN+G and 45.8% in patients receiving GClb.',
							answerSize: 957,
							redirect: '/patient/gordon/cycle-4/'
						},
					]
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(){
			this.questionPopupDisplay = false
			this.content[this.which].columnChide = false
			this.content[this.which].nextTabInterim = false
		},
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
			}
		}
	}
}
</script>